module.exports = __webpack_public_path__ + "img/info.75d40d88.svg";